import { FaWhatsapp } from 'react-icons/fa';

function WhatsApp() {
  const phoneNumber = '9472652042'; 

  return (
    <div>
    <a
      href={`https://wa.me/${phoneNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 transition-colors z-30"
    >
      <FaWhatsapp size={28} />
    </a>
    </div>
  );
};

export default WhatsApp;
